
export function type() {
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);//IOS终端
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    if (isiOS) {
        return "IOS";
    } else if (isAndroid) {
        return "ANDROID"
    } else {
        return "SYSTEM"
    }

}
export function appMessage() {
    // const u = navigator.userAgent;
    // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);//IOS终端
    // const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    // //console.log(isAndroid)
    // if (isiOS) {
    //     window.webkit.messageHandlers.userInfo.postMessage();
    // } else if (isAndroid) {
    //     UNIEV_BRIDGE.userInfo();
    // }
    var bridge = getJsBridge();
    var str = bridge.call("userInfo", { msg: "userInfo" });
    bridge.call("testAsyn", { msg: "testAsyn" }, function (v) {
        alert(v);
    })
}
export function objKeySort(obj) {//排序的函数
    var newkey = Object.keys(obj).sort();
    var time = Date.now();
    //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    var o = {
        appId: 1448919637847162882,
        timestamp: time
    }
    var newObj = Object.assign({}, o);//创建一个新的对象，用于存放排好序的键值对
    console.log(newObj)
    for (var i = 0; i < newkey.length; i++) {//遍历newkey数组
        newObj[newkey[i]] = obj[newkey[i]];//向新创建的对象中按照排好的顺序依次增加键值对
    }
    var obj = {}
    var arr = []
    for (var key in newObj) {
        arr.push(key + "=" + newObj[key]);
    }
    obj = arr.join("")
    return obj;//返回排好序的新对象
}
// 图片预览
export function ImagePreview(imgData, that, imgSrc, index, list) {
    const param = {
        x: imgData.x,
        y: imgData.y,
        width: imgData.width,
        height: imgData.height,
        left: imgData.getBoundingClientRect().left,
        top: imgData.getBoundingClientRect().top,
        src: imgSrc,
        index,
        imgList: list,
    };
    that.$bridge.call('NativeController.previewImage', param);
    console.log(param);
}